import { hydrateRoot } from 'react-dom/client';
import { ReactRelayContext, RelayEnvironmentProvider } from 'react-relay';
import { createOperationDescriptor, getRequest } from 'relay-runtime';
import { IntlProvider } from 'dibs-react-intl';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import SV from 'server-vars';
import { ServerVarsContextProvider } from '../shared/ServerVarsContext';

import { ProjectRootQuery, type ProjectRootQueryType } from '../interiorsProject/ProjectRootQuery';
import { type InteriorProjectWrapper_viewer$key } from '../interiorsProject/__generated__/InteriorProjectWrapper_viewer.graphql';
import InteriorProjectWrapper from '../interiorsProject/InteriorProjectWrapper';
import { getEnvironment } from '../relayModernEnvironment';

const environment = getEnvironment(true);

const locale = SV.get('locale');
const messages = SV.get('messages');
const isPreview = SV.get('isPreview') || false;
const variables: ProjectRootQueryType['variables'] = SV.get('relayVariables');

const operation = createOperationDescriptor(getRequest(ProjectRootQuery), variables);
const snapshot = environment.lookup(operation.fragment);

initializeDBL().then(() => {
    const interiorProjectDOMNode = document.getElementById('js-root');

    if (interiorProjectDOMNode !== null) {
        hydrateRoot(
            interiorProjectDOMNode,
            <IntlProvider locale={locale} messages={messages}>
                <ServerVarsContextProvider
                    isMobile={SV.get('settings.isMobile')}
                    isTablet={SV.get('settings.isTablet')}
                    isDesktop={SV.get('settings.isDesktop')}
                >
                    <RelayEnvironmentProvider environment={environment}>
                        <ReactRelayContext.Provider value={{ environment }}>
                            <InteriorProjectWrapper
                                isPreview={isPreview}
                                viewer={snapshot?.data?.viewer as InteriorProjectWrapper_viewer$key}
                            />
                        </ReactRelayContext.Provider>
                    </RelayEnvironmentProvider>
                </ServerVarsContextProvider>
            </IntlProvider>
        );
    }
});
